import React, { Component } from 'react';

import './style.css';

export default class AboutSection extends Component {
  render() {
    return (
      <section className='bg-light page-section' id='about'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 text-center'>
              <h2 className='section-heading text-uppercase'>Who Am I ?</h2>
            </div>
          </div>
          <div className='row'>
            <div className='offset-sm-4 col-sm-4'>
              <div className='team-member'>
                <img
                  className='mx-auto rounded-circle'
                  src='img/team/formal.jpeg'
                  alt=''
                />
                <h4>Mohamed Khaled</h4>
                <p className='text-muted role'>
                  Full-Stack Javascript Developer
                </p>
                <div className='contactCont'>
                  <i
                    className='fa fa-envelope contactIcon'
                    aria-hidden='true'
                  ></i>
                  <span className='contactData'>M.Khaled1499@gmail.com</span>
                </div>
                <div className='contactCont'>
                  <i className='fa fa-phone contactIcon' aria-hidden='true'></i>
                  <span className='contactData'>+20 10 23 77 32 53</span>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-8 mx-auto text-center'>
              <p className='large text-muted'>
                Senior Front-End Engineer with expertise in{' '}
                <span className='skill'>React</span>,{' '}
                <span className='skill'>Angular</span> , and{' '}
                <span className='skill'>React Native </span> . Extensive
                experience building websites using{' '}
                <span className='skill'>React</span> and{' '}
                <span className='skill'>Angular</span> and developing
                cross-platform mobile applications with{' '}
                <span className='skill'>React Native</span> . Proven track
                record of successful project delivery and leadership. Skilled in
                creating interactive user interfaces and optimizing application
                performance. Seeking a senior role in React Native development
                to leverage my experience and drive the development of
                cutting-edge cross-platform mobile apps.
              </p>
            </div>
          </div>

          <div className='row'>
            <div className='offset-sm-4 col-sm-4'>
              <ul className='list-inline social-buttons'>
                <li className='list-inline-item'>
                  <a
                    href='https://github.com/Mk1499/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-github'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a
                    href='https://www.facebook.com/mohamed.khaled.114'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-facebook-f'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a
                    href='http://linkedin.com/in/mk1499'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-linkedin-in'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a
                    href='https://www.hackerrank.com/m_khaled1499'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-hackerrank'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a
                    href='https://www.behance.net/mk1499'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-behance'></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
